export default {
  ca: {
    qc: 'qc'
  },
  us: {
    // @todo stubbed
  }
}
